import { createContext } from 'react'

const accentContext = createContext()

export default accentContext
